import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

/**
 * 认证状态管理 Hook
 * 提供便捷的认证状态访问和操作方法
 */
export const useAuth = () => {
  const context = useContext(AuthContext);
  
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
};

export default useAuth;